import { render, staticRenderFns } from "./StockTrfDetails_Action.vue?vue&type=template&id=28ef1cd1&"
import script from "./StockTrfDetails_Action.vue?vue&type=script&lang=js&"
export * from "./StockTrfDetails_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports